import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../layout/Layout';
import ServiceLayout from '../components/ServiceLayout';

export default function WebApplication() {
  return (
    <Layout>
      <ServiceLayout
        title="Web Application"
        banner="/assets/images/banner/web.jpg"
        current="/web-application"
      >
        <div className="space-y-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-brand-dark mb-4">Web Application</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Welcome to our innovative software development platform! We specialize in crafting cutting-edge applications tailored to your unique needs, utilizing technologies such as React, Next.js, Vue.js, AngularJS, and Python for frontend development, and Node.js and Python for backend development. With expertise in databases like MongoDB, MySQL, Microsoft SQL Server, and Oracle, we ensure flexibility and scalability for your data management needs.
            </p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 list-none p-0">
              {['Seamless Interaction', 'Resource Optimization'].map((item) => (
                <li key={item} className="flex items-center gap-3 text-brand-dark/80 text-sm">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand/10 flex items-center justify-center">
                    <span className="icon-check-circle text-brand text-xs"></span>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <img src="website.png" alt="#" className="w-full rounded-2xl shadow-md" />

          <div>
            <p className="text-gray-600 leading-relaxed mb-6">
              Unlock the potential of your business with our custom web applications, designed to streamline operations and enhance user experiences. Harness the power of innovation and efficiency with our tailored web solutions.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                { icon: 'icon-web-design', title: 'Custom Solutions', desc: 'We recognize the value of crafting unique solutions tailored to your needs. Whether it\'s a sophisticated business solution or a basic web application, we cope with your specific requirements.' },
                { icon: 'icon-data', title: 'Scalability and Performance', desc: 'Our solutions are built with scalability and performance in mind, ensuring your application can handle increased user traffic and data loads as your business grows.' },
              ].map(({ icon, title, desc }) => (
                <div key={title} className="flex items-start gap-4 bg-gray-50 rounded-xl p-5 border border-gray-100">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-brand flex items-center justify-center">
                    <span className={`${icon} text-white text-xl`}></span>
                  </div>
                  <div>
                    <h3 className="text-brand-dark font-bold font-heading mb-2">{title}</h3>
                    <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="flex-1">
              <p className="text-gray-600 leading-relaxed mb-4">
                We go beyond deployment, providing continuous support and maintenance to keep your application secure and optimized. Our team assists with new features, bug fixes, and security concerns, ensuring your peace of mind.
              </p>
              <ul className="space-y-2 list-none p-0">
                {[
                  'Ensure seamless operation with continuous support and maintenance services.',
                  'Stay ahead with timely updates and security patches for your application.',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                    <span className="icon-tick text-brand flex-shrink-0 mt-0.5"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex-shrink-0 md:w-48">
              <img src="/assets/images/services/img2.png" alt="#" className="w-full rounded-xl shadow-sm" />
            </div>
          </div>
        </div>
      </ServiceLayout>
    </Layout>
  );
}
